export default () => {
  // eslint-disable-next-line no-unused-expressions
  !(function () {
    const i = '9jtIQr'; const a = window; const d = document

    function g () {
      const g = d.createElement('script'); const s = 'https://www.goftino.com/widget/' + i
      const l = localStorage.getItem('goftino_' + i)
      // eslint-disable-next-line no-unused-expressions,no-sequences
      g.async = !0, g.src = l ? s + '?o=' + l : s; d.getElementsByTagName('head')[0].appendChild(g)
    }
    d.readyState === 'complete' ? g() : a.attachEvent ? a.attachEvent('onload', g) : a.addEventListener('load', g, !1)
  }())
}
